import { useContext } from "react";
import ComputeContext from "../../store/ComputeContext";
import styles from "./style.module.css";

export default function Controls({ nodeComponent, node }) {
  const { state: ComputeState, methods: ComputeMethods } =
    useContext(ComputeContext);

  if (!nodeComponent?.controls.length)
    return <div className={styles.nodeIcon}>{nodeComponent.icon()}</div>;

  return nodeComponent?.controls.map((control) => {
    const inputs = ComputeMethods.getInputs(
      node.id,
      ComputeState.computedValues
    );

    return (
      <div
        key={control.id}
        onMouseDown={(e) => e.stopPropagation()}
        onDrag={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
      >
        {control.Render({
          // TODO
          value: ComputeState.controlValues[`${node.id}:${control.id}`],
          onChange: (value) => {
            ComputeMethods.setControlValue(`${node.id}:${control.id}`, value);
          },
          inputs,
        })}
      </div>
    );
  });
}
